import { useEffect, useState } from "react";
import NotificationAlert from "./NotificationAlert";

interface AlertProps {
    type?: "success" | "error" | "warning"
    content?: string,
    title?: string,
    icon?: string;
    dateTime?: string;
    visible?: boolean;
}

const Alert = (props: AlertProps) => {
    const { type, content, title, icon, dateTime, visible } = props;
    const [showSnackBar, setShowSnackBar] = useState(false);
    const snackbar = {
        color: type ?? "success",
        content: content ?? "Save Successful!",
        title: title ?? "Success",
        icon: icon ?? "check",
        dateTime: dateTime ?? "just now",
    };
    
    const openSnackBar = () => setShowSnackBar(true);
    const closeSnackBar = () => setShowSnackBar(false);

    useEffect(() => {
        if(visible)
            openSnackBar();
        else
            closeSnackBar();
    }, [visible]);

    return (
        <NotificationAlert 
            open={showSnackBar}
            onClose={closeSnackBar}
            close={!showSnackBar}
            color={snackbar.color}
            icon={snackbar.icon}
            title={snackbar.title}
            content={snackbar.content}
            dateTime={snackbar.dateTime}
        />
    );
}
export default Alert;